import { useState } from 'react';

const navItems = [
  { label: '首页', href: '#top' },
  { label: '事件流', href: '#stream' },
  { label: '持续跟进', href: '#followup' },
  { label: '热榜', href: '#hot' },
];

export default function SiteHeader() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200/70 bg-background-50/85 backdrop-blur-md">
      <div className="w-full px-4 md:px-6 h-16 flex items-center justify-between gap-4">
        <a href="#top" className="flex items-center gap-2 shrink-0">
          <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 dark:text-foreground-950 flex items-center justify-center">
            <i className="ri-fire-fill text-lg"></i>
          </span>
          <span className="font-heading text-xl md:text-2xl text-foreground-950 tracking-wide">瓜圈速报</span>
        </a>

        <nav className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <a
              key={item.label}
              href={item.href}
              className="px-3.5 py-2 rounded-md text-sm font-medium text-foreground-700 hover:text-primary-600 hover:bg-primary-50 transition-colors cursor-pointer whitespace-nowrap"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <button
            type="button"
            aria-label="搜索"
            onClick={() => setSearchOpen((prev) => !prev)}
            className="w-9 h-9 rounded-md flex items-center justify-center text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
          >
            <i className="ri-search-line text-lg"></i>
          </button>
          <a
            href="#subscribe"
            className="hidden sm:inline-flex items-center gap-1.5 rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 dark:text-foreground-950 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-notification-3-line"></i>
            订阅速报
          </a>
          <button
            type="button"
            aria-label="菜单"
            onClick={() => setMobileOpen((prev) => !prev)}
            className="md:hidden w-9 h-9 rounded-md flex items-center justify-center text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
          >
            <i className={mobileOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
          </button>
        </div>
      </div>

      {searchOpen && (
        <div className="w-full px-4 md:px-6 pb-4">
          <div className="relative">
            <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-base"></i>
            <input
              type="text"
              placeholder="搜索瓜主、事件关键词…"
              className="w-full rounded-md border border-background-300/70 bg-background-50 pl-10 pr-4 py-2.5 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400/60"
            />
          </div>
        </div>
      )}

      {mobileOpen && (
        <div className="md:hidden w-full px-4 pb-4 flex flex-col gap-1 border-t border-background-200/70 pt-3">
          {navItems.map((item) => (
            <a
              key={item.label}
              href={item.href}
              onClick={() => setMobileOpen(false)}
              className="px-3 py-2.5 rounded-md text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
            >
              {item.label}
            </a>
          ))}
          <a
            href="#subscribe"
            onClick={() => setMobileOpen(false)}
            className="mt-1 inline-flex items-center justify-center gap-1.5 rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 dark:text-foreground-950 transition-colors cursor-pointer"
          >
            <i className="ri-notification-3-line"></i>
            订阅速报
          </a>
        </div>
      )}
    </header>
  );
}